import { useEffect } from "react";
import { Typography } from "components/atoms";
import { BackIcon } from "components/atoms/Icon";
import { useNavigate } from "react-router-dom";
import { useScreenSize } from "hooks";
import { MOBILE_WIDTH } from "utils/constants";
import { useGetGMACMaterialsQuery } from "services/homeApi";
import "./index.scss";

interface IProps {
  theme: "light" | "dark";
}

export const GMATMaterialMobile = ({ theme }: IProps) => {
  const navigate = useNavigate();
  const screen = useScreenSize();
  const { data: gmacMaterialsData, isLoading } = useGetGMACMaterialsQuery();

  // Sort materials by Order property
  const sortedMaterials = gmacMaterialsData?.Materials
    ? [...gmacMaterialsData.Materials].sort((a, b) => a.Order - b.Order)
    : [];

  const handleBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (screen.width > MOBILE_WIDTH) {
      navigate(-1);
    }
  }, [screen.width]);

  return (
    <div className="material-mobile-wrapper">
      <div className="back-section">
        <BackIcon
          color={theme === "light" ? "#273E5A" : "#329EE2"}
          onClickHandle={handleBack}
        />
        <Typography label="Back" variant="h6Medium" onClick={handleBack} />
      </div>

      <Typography
        label="Official GMAC Material"
        variant="h2Bold"
        styles="gmat-material-modal-header-typography-custom-style"
      />

      <Typography
        label="VITALSOURCE BOOKSHELF (EBOOK ACCESS)"
        variant="h4Med"
        styles="gmat-material-text-style custom-typo-style custom-topic-styles"
      />
      <Typography
        label="VitalSource Bookshelf is the world’s leading platform for distributing, accessing, consuming, and engaging with digital textbooks and course materials."
        variant="h8Book"
        styles="gmat-material-text-style custom-typo-style"
      />
      <Typography
        label="To access for the first time:"
        variant="h8Book"
        styles="gmat-material-text-style custom-typo-style"
      />
      <Typography
        label={
          <>
            1. Visit{" "}
            <a
              className="gmat-material-text-link"
              href="https://bookshelf.vitalsource.com/#/user/signin"
            >
              VitalSource Bookshelf Online
            </a>
          </>
        }
        variant="h8Book"
        styles="custom-typo-style"
      />
      <Typography
        label="2. Click Create a VitalSource Account"
        variant="h8Book"
        styles="custom-typo-style"
      />
      <Typography
        label="3. Enter an email and password to create your account."
        variant="h8Book"
        styles="custom-typo-style"
      />
      <Typography label="4. Log into your account." variant="h8Book" />
      <Typography
        label="5. Click Redeem Codes, which is located at the bottom right of the page."
        variant="h8Book"
        styles="custom-typo-style"
      />
      <Typography
        label="6. Enter your code for the Official Guide ebook and any other ebooks that came with your course. All your codes are at the bottom of this message."
        variant="h8Book"
        styles="custom-typo-style"
      />
      <Typography
        label="7. If you get an error when trying to redeem a code, please check that you used the code for the ebook rather than the code for the question bank."
        variant="h8Book"
        styles="custom-typo-style"
      />
      <Typography
        label="8. (Optional) Download the desktop app by clicking the apps button in the upper right corner of the screen."
        variant="h8Book"
        styles="custom-typo-style"
      />
      <Typography
        label="9. (Optional) You can also download a mobile app by searching for VitalSource Bookshelf in the app store for your mobile device. There are mobile versions available for both Apple and Android devices."
        variant="h8Book"
        styles="custom-typo-style"
      />
      <Typography
        label="10. If you plan to access your ebooks using the VitalSource Bookshelf website, bookmark the website."
        variant="h8Book"
        styles="custom-typo-style"
      />
      <Typography
        label="Question Bank Access"
        variant="h4Med"
        styles="gmat-material-text-style custom-topic-styles custom-topic-question-bank"
      />
      <Typography
        label="To access for the first time:"
        variant="h8Book"
        styles="gmat-material-text-style custom-typo-style"
      />

      <Typography
        label={
          <>
            1. Visit{" "}
            <a
              className="gmat-material-text-link"
              href="http://MBA.com"
              target="__blank"
            >
              http://MBA.com
            </a>
          </>
        }
        variant="h8Book"
        styles="custom-typo-style"
      />
      <Typography
        label={
          <>
            2. Log into your{" "}
            <a
              className="gmat-material-text-link"
              href="http://MBA.com"
              target="__blank"
            >
              http://MBA.com
            </a>{" "}
            account.
          </>
        }
        variant="h8Book"
        styles="custom-typo-style"
      />
      <Typography
        label="3. Click Access GMAT Focus Official Starter Kit (Free)."
        variant="h8Book"
        styles="custom-typo-style"
      />
      <Typography
        label="4. Click the Redeem Activation Codes button."
        variant="h8Book"
        styles="custom-typo-style"
      />
      <Typography
        label="5. Enter your activation code."
        variant="h8Book"
        styles="custom-typo-style"
      />
      <Typography
        label="6. Click confirm."
        variant="h8Book"
        styles="custom-typo-style"
      />
      <Typography
        label="7. Click Study for the Drill Bank item."
        variant="h8Book"
        styles="custom-typo-style"
      />

      <div className="gmac-key-values-container">
        {isLoading ? (
          <Typography
            label="Loading..."
            variant="h8Book"
            styles="custom-typo-style"
          />
        ) : sortedMaterials.length > 0 ? (
          sortedMaterials.map((material, index) => (
            <div key={index} className="gmac-key-value-wrapper">
              <Typography
                variant="h6Medium"
                label={`Your ${material.Name} PIN: `}
                styles="gmac-key-custom-style"
              />
              <Typography
                label={material.Pin}
                variant="h6Book"
                styles="gmac-value-custom-style"
              />
            </div>
          ))
        ) : null}
      </div>
    </div>
  );
};
